/* eslint-disable no-bitwise */

import { UntypedFormGroup } from "@angular/forms";
import { Cellstyle } from "~app/common/components/hot-doc/hotdoc/cell";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ProduktmatrisGrid } from "../../produktinstruktioner-details/matris/ProduktmatrisGrid";
import { EmptyCell } from "../../produktinstruktioner-details/matris/cells/emptyCell";
import { FargCell } from "../../produktinstruktioner-details/matris/cells/fargCell";
import { ProduktdefinitionHeaderData } from "../ProduktdefinitionHeaderData";
import { LangdDiameterMatris } from "./LangdDiameterMatris";

export class FargmarkningMatris extends LangdDiameterMatris {

    constructor(grid: ProduktmatrisGrid,
        form: UntypedFormGroup,
        headerData: ProduktdefinitionHeaderData,
        canEdit: boolean) {
        super(grid, form, headerData, canEdit);
    }

    getFargmarkning(raskModalService: RaskModalService, form: UntypedFormGroup, accessor: (startlangd, startdiameter) => any): HotDoc {
        const colFactory = () => this.buildColumnDefinitions({
            readOnly: !this.canEdit,
            type: "text",
            editor: false
        });
        const rowFactory = (doc: HotDoc) => this.buildRowDefinitions(
            doc,
            {
                cellFactory: (pmData) => new FargCell(pmData, form, accessor, Cellstyle.Default | Cellstyle.AlignCenter),
                columnSummaryFactory: (cells) => new EmptyCell(),
                rowSummaryFactory: (cells) => new EmptyCell(),
                sumOfSumsFactory: (cells) => new EmptyCell()
            }, raskModalService, false);
        const settingsFactory = (doc: HotDoc) => this.getBaseSettings(doc, raskModalService, { outsideClickDeselects: this.outsideClickDeselector });

        return new HotDoc(colFactory, rowFactory, settingsFactory);
    }

    setFargMarkning(hotDoc: HotDoc, fargmarkning: number, cells: any[]) {
        const produktmatriser = this.getCellsOfType(cells, hotDoc, FargCell).map(x => x.prismatris);
        produktmatriser.forEach((cell) => {
            switch(fargmarkning) {
                case 1:
                    cell.markning1 = true;
                    cell.markAsDirty();
                    this.form.markAsDirty();
                    break;
                case 2:
                    cell.markning2 = true;
                    cell.markAsDirty();
                    this.form.markAsDirty();
                    break;
                case 3:
                    cell.markning3 = true;
                    cell.markAsDirty();
                    this.form.markAsDirty();
                    break;
            }
        });
        hotDoc.rebind();
    }

    rensaFargmarkering(hotDoc: HotDoc,  cells: any[]) {
        const produktmatriser = this.getCellsOfType(cells, hotDoc, FargCell).map(x => x.prismatris);
        produktmatriser.forEach(x => {
            if(x.markning1 || x.markning2 || x.markning3) {
                x.markAsDirty();
                this.form.markAsDirty();
            }
            x.markning1 = undefined;
            x.markning2 = undefined;
            x.markning3 = undefined;
        });
        hotDoc.rebind();
    }
}
